<template>
  <base-dialog-form ref="managePortalDialog" :title="$t('manage_portal')"
    :text="systemInfo.custId + ' - ' + systemInfo.ragSoc" width="50%" color="secondary" icon="mdi-earth">
    <template v-slot:actions>
      <v-row class="justify-center">
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" @click="savePortal" color="success">{{
            $t("save")
          }}</v-btn>
          <v-btn class="mx-5" @click="$refs.managePortalDialog.close()" color="warning">{{ $t("undo") }}</v-btn>
          <v-btn class="mx-5" @click="deletePortal" color="error">{{
            $t("delete")
          }}</v-btn>
        </v-col>
      </v-row>
    </template>

    <v-row justify="space-between">
      <v-col cols="12">
        <v-text-field v-model="systemInfo.adminUser" :label="$t('admin_user')" :rules="requiredEmail"></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field v-model="systemInfo.hostname" :label="$t('dns')"
          :prepend-icon="dnsError ? 'mdi-close-circle' : 'mdi-check-circle'" :error="dnsError" @change="checkDNS"
          :error-messages="dnsErrorMsg"></v-text-field>
        <v-banner>
          <v-avatar slot="icon" color="secondary" size="40">
            <v-icon large dark> mdi-information-variant </v-icon>
          </v-avatar>
          <div v-html="systemInfo.help"></div>
        </v-banner>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-autocomplete v-model="systemInfo.importUsers" :items="selectUsers" item-text="text" item-value="value"
          :label="$t('import_users_in_portal')" multiple chips></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-autocomplete v-model="systemInfo.importRoles" :items="selectRoles" item-text="text" item-value="value"
          :label="$t('import_role_in_portal')" multiple chips></v-autocomplete>
      </v-col>
    </v-row>
  </base-dialog-form>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "manage-portal",
  components: {
    Swal,
  },
  data() {
    return {
      custId: null,
      dnsError: null,
      dnsErrorMsg: null,
      selectUsers: null,
      selectRoles: null,
      RBAC_system_VIEW_SYSTEM: false,
      RBAC_system_CAN_DEPLOY: false,
      systemInfo: {
        hostname: null,
        adminUser: null,
        importUsers: null,
      },
      required: [(value) => !!value || this.$t("required_field")],
      requiredEmail: [
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t("email_must_be_valid"),
      ],
    };
  },
  methods: {
    checkDNS() {
      let _ = this;
      _.dnsError = null;
      _.dnsErrorMsg = null;
      _.chiamataAxios(
        "GET",
        _.custId
          ? "/auth/portal/checkDns/" + _.systemInfo.hostname + "/" + _.custId
          : "/auth/portal/checkDns/" + _.systemInfo.hostname,
        { msg: "none" }
      ).then((response) => {
        if (response.msg.severity > 0) {
          _.dnsError = true;
          _.dnsErrorMsg = msg.msgTxt;
        }
      }, "none");
    },
    open(custId) {
      this.loadData(custId);
    },
    deletePortal() {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/portal/deletePortal/" + _.custId,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.$emit("isUpdated", "true");
              _.$refs.managePortalDialog.close();
            } else {
              return false;
            }
          });
        }
      });
    },
    savePortal() {
      let _ = this;
      let newObj = _.systemInfo;

      if (_.typeDNS === "managed")
        newObj.hostname = _.prefixDNS + "." + _.managedDNS;

      _.chiamataAxios("PUT", "/auth/portal/savePortal/" + _.custId, {
        body: newObj,
        dialogLoader: true,
      }).then(
        (response) => {
          if (response.msg.esito) {
            _.$emit("isUpdated", "true");
            _.$refs.managePortalDialog.close();
            return true;
          } else {
            return false;
          }
        },
        "always",
        500
      );
    },
    loadData(custId) {
      let _ = this;
      _.dnsError = null;
      _.dnsErrorMsg = null;

      _.selectUsers = [];
      _.chiamataAxios("POST", "/auth/portal/listUsers", {
        body: { filter: {} },
      }).then((response) => {
        _.selectUsers = response.data.map(function (item) {
          return {
            value: item.masterId,
            text:
              item.surname +
              " " +
              item.name +
              "   -   " +
              item.resCity +
              " (" +
              item.eta +
              " anni)",
          };
        });
      });

      _.selectRoles = [];
      _.chiamataAxios("GET", "/auth/portal/listRole", {
        body: { filter: {} },
      }).then((response) => {
        _.selectRoles = response.data
          .filter((item) => {
            return item.code !== "root";
          })
          .map(function (item) {
            return {
              value: item.code,
              text: _.$t(item.code),
            };
          });
      });

      _.chiamataAxios(
        "GET",
        custId
          ? "/auth/portal/getPortalInfo/" + custId
          : "/auth/portal/getPortalInfo"
      ).then((response) => {
        _.custId = response.data.custId;
        _.systemInfo = response.data;
        if (response.data.dnsCheck && response.data.dnsCheck.msg.severity > 0) {
          _.dnsError = true;
          _.dnsErrorMsg = response.data.dnsCheck.msg.msgTxt;
        }
        _.$refs.managePortalDialog.open();
      });
    },
  },
  mounted() {
    let _ = this;
    _.RBAC_system_VIEW_SYSTEM = _.checkUserRole("system", "VIEW_SYSTEM");
    _.RBAC_system_CAN_DEPLOY = _.checkUserRole("system", "CAN_DEPLOY");
  },
  computed: {
    adminPortal() {
      if (window.systemData) return window.systemData.adminPortal;
      else return false;
    },
  },
};
</script>